import { React, useState, useRef, useEffect } from 'react';
import urls from "../../api/urls.json";
import { FlexWrapper, ParentDiv } from '../../styles/WrapperStyles'
import { styled, css } from 'styled-components'
import Loader from "../Loader";
import ImageWrapper from "../ImageWrapper";
import previous_inctive from '../../assests/arrow_back_grey.png';
import next_inactive from '../../assests/arrow_forward_grey.png';
import previous_active from '../../assests/arrow_back.png';
import next_active from '../../assests/arrow_forward.png';
import { BottomButton } from '../../styles/ButtonStyles'
import CropImage from '../CropImage';
import PageModal from "../modals/PageModal";
import { authorizedHttpGet, authorizedHttpPost } from '../../api/httpCalls';
import EmptyView from '../EmptyView'
import LeftNav from "../LeftNav";
import { useLocation, useNavigate } from "react-router-dom";
import '../styles/Verified.css'
import '../styles/People.css'
import ReviewPage from '../ReviewPage';
import { convertTimestampToFormattedDate } from "../../utils";
import verified_icon from '../../assests/verified.svg';
import { uploadCroppedImageToS3 } from '../../api/imageUpload';
import VerifyModal from '../modals/VerifyModal';
import placeholder_image from '../../assests/placeholder_image.png';
import ShareRefControl from '../ShareRefControl';


const HeaderWrapper = styled(FlexWrapper)`
    margin-left: 200px;
    min-height: 55px;
    height: auto;
    padding: 0 30px 0 30px;
    border-radius: 27.5px;
    background-color: #f8f8fa;
    align-items:center;
    box-sizing: border-box;
    flex-wrap: wrap;
    row-gap: 8px;
    ${props => props.width && css`
        width:${props.width}
    `}
    margin-top: 10px;
    width: calc(100vw - 320px);
    max-width: calc(100vw - 320px);
`;

const BottomBarWrapper = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
`;


const HeaderSelected = styled.span`
  font-family: 'Gilory-Semi';
  font-size: 20px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  font-weight: 800;
  color: #767676;
  white-space: normal;
  overflow-wrap: anywhere;
    ${props =>
        props.marginRight &&
        css`
        margin-right: 10px;
      `};
`;

const ParentView3 = styled.div`
    display:flex;
    align-content:center;
    position:fixed;
    top:90%;
    left:15%;
    bottom:0;
    right:15%;
    align-items:center;
    justify-content:center;
`;

function UpdatePage() {
    const location = useLocation();
    const navigate = useNavigate();
    const authToken = localStorage.getItem('authToken');
    const isOtpVerified = localStorage.getItem('verificationPassed');
    if (!authToken || !isOtpVerified) {
        sessionStorage.setItem('redirectUrl', location.pathname)
        navigate('/login')
    }
    const [appName, setAppName] = useState(localStorage.getItem('appName'))
    const itemsPerPage = 1;
    const [currentPage, setCurrentPage] = useState(1);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const [profiles, setProfiles] = useState([]);
    const currentProfile = profiles.slice(startIndex, endIndex);
    const [displayReview, setDisplayReviewPage] = useState(false);
    const [likedProfiles, setLikedProfiles] = useState([]);
    const [passedProfiles, setPassedProfiles] = useState([]);
    const [inappProfiles, setInappProfiles] = useState([]);
    const [cropPhoto, setCropPhoto] = useState('')
    const [showCropImage, setShowCropImage] = useState(false);
    const [displaySelfieModal, setDisplaySelfieModal] = useState(false);
    const [selfieUrl, setSelfieUrl] = useState('');
    const [togglePageModal, setTogglePageModal] = useState(false);
    const totalPages = Math.ceil(profiles.length / itemsPerPage);
    const [apiPageChange, setApiPageChange] = useState(1);
    const totalPagesApi = useRef(0);
    const totalProfiles = useRef(0);
    const [isLoading, setIsLoading] = useState(false)
    const [updatedImages, setUpdatedImages] = useState([])
    const newApiPageChange = useRef(1);

    const resetState = () => {
        setCurrentPage(1);
        setLikedProfiles([]);
        setPassedProfiles([]);
        setInappProfiles([]);
        setDisplayReviewPage(false);
    }

    const handleLeftNavAppChange = (name) => {
        resetState();
        setAppName(name)
    };

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (!displayReview) {
                if (event.key === 'ArrowLeft' && currentPage > 1) {
                    if (currentPage > 1) { setCurrentPage(currentPage - 1) }
                } else if (event.key === 'ArrowRight' && currentPage < totalPages) {
                    if (currentPage < totalPages) { setCurrentPage(currentPage + 1) }
                } else if (event.key === 'Shift') {
                    if(!currentProfile){
                        return
                    }
                    handleActionButton(currentProfile, 'like');
                } else if (event.key === '/') {
                    if(!currentProfile){
                        return
                    }
                    handleActionButton(currentProfile, 'pass');
                } else if (event.key === 'i') {
                    if(!currentProfile){
                        return
                    }
                    inappProfile(currentProfile);
                } else if (event.key === 'ArrowRight') {
                    if (currentPage === totalPages) { setDisplayReviewPage(true) }
                }
            } else {
                if (event.key === 'ArrowLeft') {
                    setDisplayReviewPage(false);
                    if (currentPage > 1) { setCurrentPage(currentPage - 1) }
                }
            }
        };

        document.addEventListener('keydown', handleKeyPress);

        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    });


    const closeModal = () => {
        setShowCropImage(false);
    }

    const showImageCrop = (photo) => {
        setCropPhoto(photo)
        setShowCropImage(true);
    }

    const openSelfieModal = (url) => {
        setSelfieUrl(url);
        setDisplaySelfieModal(true);
    }

    const closeSelfieModal = () => {
        setDisplaySelfieModal(false);
        setSelfieUrl('');
    }

    const removeProfileByRef = (profileArray, refToRemove) => {
        return profileArray.filter((obj) => obj.ref !== refToRemove);
    };

    const isRefAlreadyPresent = (profileArray, refToFind) => {
        return profileArray.some((obj) => obj.ref === refToFind);
    }

    const inappProfile = (profile) => {
        if (isRefAlreadyPresent(inappProfiles, profile[0].ref)) {
            let removedProfile = removeProfileByRef(inappProfiles, profile[0].ref);
            setInappProfiles(removedProfile);
        } else {
            // Remove from other lists first
            const refToFind = profile[0].ref;
            const updatedLikedProfiles = removeProfileByRef(likedProfiles, refToFind);
            const updatedPassedProfiles = removeProfileByRef(passedProfiles, refToFind);
            setLikedProfiles(updatedLikedProfiles);
            setPassedProfiles(updatedPassedProfiles);
            
            setInappProfiles(existingData => ([...existingData, ...profile]));
            
            if (profiles.length === currentPage) {
                setDisplayReviewPage(true);
            } else {
                setCurrentPage(currentPage + 1);
            }
        }
    }

    const handleActionButton = (p, button) => {
       if(!p[0]){
           return
       }
        let changeCurrentPage = false;
        if (button === 'like') {
            if (isRefAlreadyPresent(likedProfiles, p[0].ref)) {
                const updatedLikedProfiles = removeProfileByRef(likedProfiles, p[0].ref);
                setLikedProfiles(updatedLikedProfiles);
                changeCurrentPage = false;
            } else {
                const refToFind = p[0].ref;
                const updatedPassedProfiles = removeProfileByRef(passedProfiles, refToFind);
                const updatedInappProfiles = removeProfileByRef(inappProfiles, refToFind);
                setPassedProfiles(updatedPassedProfiles);
                setInappProfiles(updatedInappProfiles);
                setLikedProfiles(existingData => ([...existingData, ...p]));
                changeCurrentPage = true;
            }
        } else if (button === 'pass') {
            if (isRefAlreadyPresent(passedProfiles, p[0].ref)) {
                const updatedPassedProfiles = removeProfileByRef(passedProfiles, p[0].ref);
                setPassedProfiles(updatedPassedProfiles);
                changeCurrentPage = false;
            } else {
                const refToFind = p[0].ref;
                const updatedLikedProfiles = removeProfileByRef(likedProfiles, refToFind);
                const updatedInappProfiles = removeProfileByRef(inappProfiles, refToFind);
                setLikedProfiles(updatedLikedProfiles);
                setInappProfiles(updatedInappProfiles);
                setPassedProfiles(existingData => ([...existingData, ...p]));
                changeCurrentPage = true;
            }
        }

        if (profiles.length === currentPage) {
            setDisplayReviewPage(true);
        }

        if (changeCurrentPage) {
            setCurrentPage(currentPage + 1);
        }
    }

    const getUsers = async () => {
        setIsLoading(true)
        let response = await authorizedHttpGet(urls.GET_IMAGES_UPDATES, { page: apiPageChange })
        if (response.status) {
            totalPagesApi.current = response.data.total_pages
            totalProfiles.current = response.data.total_profiles
            setProfiles(response.data.profiles)
            newApiPageChange.current = response.data.page
        }
        setIsLoading(false)
    }


    useEffect(() => {
        getUsers()
    }, [apiPageChange]);

    useEffect(() => {
        setApiPageChange(1)
        getUsers()
    }, [appName]);

    const handlePageChange = (direction) => {
        if (direction === 'prev' && currentPage > 1) {
            setCurrentPage(currentPage - 1);
        } else if (direction === 'next' && currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
        if (currentPage + 1 === endIndex) {
            setDisplayReviewPage(true);
        }
        if (profiles.length === currentPage) {
            setDisplayReviewPage(true);
        }
    };

    const cancelSave = () => {
        if (apiPageChange < totalPagesApi.current) {
            // setApiPageChange(Number(apiPageChange) + 1);
            setDisplayReviewPage(false);
            setCurrentPage(1);
            setLikedProfiles([]);
            setPassedProfiles([]);
        }
    }

    const saveResults = async () => {
        setIsLoading(true);
        if (likedProfiles.length === 0 && passedProfiles.length === 0 && inappProfiles.length === 0) { return; }
        const data = {
            approve: likedProfiles,
            reject: passedProfiles,
            inappropriate: inappProfiles,
            page: apiPageChange,
            tab: 'updates',
        }
        let response = await authorizedHttpPost(urls.POST_IMAGES_UPDATES, data)
        if (response.status) {
            totalPagesApi.current = response.data.total_pages
            totalProfiles.current = response.data.total_profiles
            setProfiles(response.data.profiles)
            setCurrentPage(1);
            setLikedProfiles([]);
            setPassedProfiles([]);
            setInappProfiles([]);
            setDisplayReviewPage(false);
            setIsLoading(false);
            // newApiPageChange.current = response.data.page
        }
    }

    const goToPage = (pageModalNumber) => {
        resetState();
        setTogglePageModal(false);
        if (pageModalNumber > totalPagesApi.current) {
            alert("Page number is greater than total pages");
        } else {
            setApiPageChange(pageModalNumber);
        }
    }

    const deleteImage = (index) => {
        setUpdatedImages([])
        currentProfile[0].updated_images = (currentProfile[0].updated_images.filter((obj, i) => i !== index));
        // currentProfile[0].updated_images = (currentProfile[0].updated_images.filter((obj) => obj.photo_id !== photo_id));
    }

    const addImage = (path, index) => {
        setUpdatedImages([])
        currentProfile[0].updated_images[index] = { photo: path }
        // currentProfile[0].updated_images = [...currentProfile[0].updated_images, { photo: path }]
    }

    const saveCroppedImage = async (croppedImage) => {
        try {
            setUpdatedImages([])
            const profileRef = currentProfile[0]?.ref;
            const s3Url = await uploadCroppedImageToS3(croppedImage, profileRef);
            const index = localStorage.getItem('photoIndex');
            currentProfile[0].updated_images[index] = { photo: s3Url };
            // currentProfile[0].updated_images[localStorage.getItem('photoIndex')] = { photo: croppedImage }
            setShowCropImage(false);
            setUpdatedImages([])
        } catch (error) {
            console.error("Error saving cropped image:", error);
        }
    }

    const setSelectedImage = (photo_id) => {
        setUpdatedImages([])
        currentProfile[0].updated_images.map((obj) => {
            if (obj.photo_id === photo_id) {
                obj.selected = true;
            } else {
                obj.selected = false;
            }
        });
    }

    const dragOverItem = useRef();
    const dragImageUrl = useRef();

    const dragStart = (e, position, url) => {
        dragImageUrl.current = url;
        dragOverItem.current = position;
    };

    const dragEnter = (e, position) => {
        dragOverItem.current = position;
    };

    const dropImage = () => {
        setUpdatedImages([])
        currentProfile[0].updated_images[dragOverItem.current] = { "photo": dragImageUrl.current };
        dragImageUrl.current = null;
        dragOverItem.current = null;
    }

    const screenWidth = window.innerWidth;
    const isIpad = screenWidth === 1180;

    if (displayReview) {
        return (
            <>
                {isLoading && <Loader />}
                {togglePageModal && <PageModal closeModal={() => setTogglePageModal(false)} goToPage={goToPage} page={apiPageChange} />}
                <LeftNav handleLeftNavAppChange={handleLeftNavAppChange} tabName={'Updates'} />
                <ParentDiv>
                    <FlexWrapper className='marginTop25'>
                        <HeaderWrapper onClick={() => setTogglePageModal(true)} className='cursorPointer'>
                            <HeaderSelected>{newApiPageChange.current}</HeaderSelected>
                            <HeaderSelected className='marginLeft10'>{totalPagesApi.current}</HeaderSelected>
                            <HeaderSelected className='marginLeft10'>{totalProfiles.current}</HeaderSelected>
                        </HeaderWrapper>

                    </FlexWrapper>
                </ParentDiv>
                <ReviewPage likes={likedProfiles} passed={passedProfiles} inappProfiles={inappProfiles} tabType={'updates'} cancel={cancelSave} save={saveResults} ban={[]} approveLabel="Approve" rejectLabel="Reject" inappropriateLabel="Inappropriate" />
            </>
        )
    } else {
        return (
            <div className='App'>
                {togglePageModal && <PageModal closeModal={() => setTogglePageModal(false)} goToPage={goToPage} page={apiPageChange} />}
                {showCropImage ? <CropImage photo={cropPhoto} closeModal={closeModal} saveCroppedImage={saveCroppedImage} /> : null}
                {displaySelfieModal && selfieUrl && <VerifyModal closeModal={closeSelfieModal} image={selfieUrl} hide_buttons={true} />}
                {isLoading && <Loader />}
                <LeftNav handleLeftNavAppChange={handleLeftNavAppChange} tabName={'Updates'} />
                <ParentDiv>
                    <FlexWrapper className='marginTop25'>
                        <HeaderWrapper onClick={() => setTogglePageModal(true)} className='cursorPointer'>
                            <HeaderSelected>{newApiPageChange.current}</HeaderSelected>
                            <HeaderSelected className='marginLeft10'>{totalPagesApi.current}</HeaderSelected>
                            <HeaderSelected className='marginLeft10'>{totalProfiles.current}</HeaderSelected>
                        </HeaderWrapper>

                    </FlexWrapper>
                    <HeaderWrapper className='cursorPointer'>
                        {currentProfile[0] ? <HeaderSelected className='marginLeft10'>{currentProfile[0].first_name}</HeaderSelected> : null}
                        {currentProfile[0] && currentProfile[0].is_verified ? <HeaderSelected className='marginLeft10'><img src={verified_icon} alt="Verified" />/</HeaderSelected> : '/'}
                        {currentProfile[0] ? <HeaderSelected className='marginLeft10'>/ {currentProfile[0].gender === "Male" ? "M" : "F"}</HeaderSelected> : null}
                        {currentProfile[0] ? <HeaderSelected className='marginLeft10'>/ {currentProfile[0].age}</HeaderSelected> : null}
                        {currentProfile[0] ? <HeaderSelected className='marginLeft10'>/ {currentProfile[0]?.marital_status_v1?.name || ''}/</HeaderSelected> : null}
                        {currentProfile[0] ? <HeaderSelected className='marginLeft10'>/ {currentProfile[0].language_name}</HeaderSelected> : null}
                        {currentProfile[0] ? <HeaderSelected className='marginLeft10'>/ {currentProfile[0].location_str}</HeaderSelected> : null}
                        {currentProfile[0] ? <HeaderSelected className='marginLeft10'>/ {currentProfile[0].ref}</HeaderSelected> : null}
                        {currentProfile[0] ? (
                            <ShareRefControl refValue={currentProfile[0].ref} sourceTab="Updates" compact={true} />
                        ) : null}
                        {currentProfile[0] ? <HeaderSelected className='marginLeft10'>/ {currentProfile[0].phone_code}</HeaderSelected> : null}
                        {currentProfile[0] ? <HeaderSelected className='marginLeft10'>/ {convertTimestampToFormattedDate(currentProfile[0].application_date)}</HeaderSelected> : null}
                        {currentProfile[0] ? <HeaderSelected className='marginLeft10'>{currentProfile[0].last_curator === 'hive' ? 'HIVE/' : ''}</HeaderSelected> : null}
                    </HeaderWrapper>
                </ParentDiv>
                {
                    profiles.length > 0 ? (
                        displayReview ? null : (
                            <>
                                <div className={!isIpad ? "updatesParentView" : "updatesParentViewIpad"}>
                                    {currentProfile[0] ?
                                        [0, 1, 2, 3].map((index) => {

                                            return (
                                                <div
                                                    onDragStart={(e) => dragStart(e, index, currentProfile[0].updated_images[index].photo)}
                                                    onDragEnter={(e) => dragEnter(e, index)}
                                                    onDragEnd={dropImage}
                                                    className='dragDropContainer'
                                                >
                                                    <ImageWrapper key={index} src={currentProfile[0].updated_images[index]} canDelete={currentProfile[0].updated_images.length > 1} deleteImage={deleteImage} addImage={addImage} selectedImage={setSelectedImage} showImageCrop={showImageCrop} photoIndex={index} />
                                                </div>
                                            )

                                        }) : null
                                    }
                                </div>
                                
                                {/* Selfie Verification Placeholder */}
                                {currentProfile[0] && !displaySelfieModal && (
                                    <div className={!isIpad ? "selfieVerificationContainer" : "selfieVerificationContainerIpad"}>
                                        {(() => {
                                            const selfieUrl = currentProfile[0]?.selfie_url;
                                            
                                            // Show clickable selfie thumbnail if we have data
                                            if (selfieUrl) {
                                                return (
                                                    <div onClick={() => openSelfieModal(selfieUrl)}>
                                                        <img 
                                                            src={selfieUrl} 
                                                            alt="Selfie Verification" 
                                                            className="selfieVerificationThumbnail"
                                                            onError={(e) => e.target.src = placeholder_image}
                                                        />
                                                        <div className="selfieVerificationLabel">Selfie</div>
                                                    </div>
                                                );
                                            }
                                            
                                            // Show no selfie state
                                            return (
                                                <div className="noSelfieIndicator">
                                                    <div className="noSelfieText">No<br/>Selfie</div>
                                                </div>
                                            );
                                        })()}
                                    </div>
                                )}
                                
                                <div className={!isIpad ? "parentView1" : "parentView1Ipad"}>
                                    {
                                        currentProfile[0] ?
                                            currentProfile[0].approved_images.slice(-4).map((photo, index) => {
                                                return <ImageWrapper key={index} src={photo} selectedImage={() => { }} />
                                            }) : null
                                    }
                                </div>
                                <ParentView3 className='overflowX'>
                                    <BottomBarWrapper>
                                        {currentPage === 1 ? <img src={previous_inctive} alt="Previous page (disabled)" /> : <img src={previous_active} alt="Previous page" onClick={() => handlePageChange('prev')} />}
                                        <BottomButton buttonLike className={isRefAlreadyPresent(likedProfiles, currentProfile[0].ref) ? 'likeButtonActiveStyle' : 'likeButtonInActiveStyle'} onClick={() => handleActionButton(currentProfile, 'like')}>Accept</BottomButton>
                                        <BottomButton buttonPass className={isRefAlreadyPresent(passedProfiles, currentProfile[0].ref) ? 'passButtonActiveStyle' : 'passButtonInActiveStyle'} onClick={() => handleActionButton(currentProfile, 'pass')}>Reject</BottomButton>
                                        <BottomButton className={isRefAlreadyPresent(inappProfiles, currentProfile[0].ref) ? 'inappButtonActiveStyle' : 'inappButtonInActiveStyle'} onClick={() => inappProfile(currentProfile)}>Inappropriate</BottomButton>
                                        {currentPage === 20 ? <img src={next_inactive} alt="Next page (disabled)" onClick={() => handlePageChange('next')} /> : <img src={next_active} alt="Next page" onClick={() => handlePageChange('next')} />}
                                    </BottomBarWrapper>
                                </ParentView3>
                            </>

                        )
                    ) : <EmptyView />
                }
            </div>
        );
    }


}



export default UpdatePage;
